module.exports = __webpack_public_path__ + "img/fou.ff2665ec.png";